import React from 'react';
import styles from './agentHierarchyStatusBadge.module.css';

interface AgentHierarchyStatusBadgeProps {
    isActive: boolean;
}

export const AgentHierarchyStatusBadge: React.FC<AgentHierarchyStatusBadgeProps> = ({ isActive }) => {
    return (
        <span className={`${styles.badge} ${isActive ? styles.active : styles.inactive}`}>
            {isActive ? 'Active' : 'Inactive'}
        </span>
    );
};
